import importExport from './import&export.vue'
import moment from 'moment'
export default {
  components: { importExport },
  methods: {
    importProduct() {
      this.$refs['importExport'].importProduct();
    },
    // 导出 --新接口
    onExport() {
      let _this = this
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let params = {
        ...this.exportData.filterData,
        exportColumnList: [],
      };
      params.searchType = params.searchType.length == 2 ? 0 : params.searchType[0]
      this.columnData.forEach(v => {
        params.exportColumnList.push({
          columnName: v.label,
          fieldName: v.prop
        });
      });
      this.$q.commoditySales.productSaleDetailExport({ data: params }).then((res) => {
        if (res.message) {
          var timer = setInterval(function () {
            _this.$q.common
              .reportTaskInfo({ fragment: [res.message] })
              .then(res => {
                if (res.data.taskStatus == "执行完成") {
                  loading.close();
                  clearInterval(timer);
                  _this.downloadRes(res.data.filePath, res.data.fileName);
                }
                if (res.data.taskResult == "失败") {
                  _this.$message.error(res.data.failReason)
                  loading.close();
                  clearInterval(timer);
                }
              })
          }, 3000);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    async downloadRes(url, fileName) {
      let response = await fetch(url, { mode: "cors" });
      let blob = await response.blob();
      let objectUrl = window.URL.createObjectURL(blob);
      let a = document.createElement("a");
      a.href = objectUrl;
      a.download = fileName + "" + url.substring(url.lastIndexOf("."));
      a.click();
      a.remove();
    },
  }
}